import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
import { queryMutations } from './utils/service';
import { makeMutationsArray } from './utils/helpers';
import ResistanceInput from './components/ResistanceInput';
import ResistanceReport from './components/ResistanceReport';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      analyze: false,
      version: '',
      drugResistances: [],
      mutations: {
        pr: {
          V32I: true,
          L76V: true
        },
        rt: {
          T69ins: true
        },
        in: {}
      }
    };

    this.setMutations = this.setMutations.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount() {
    this.setMutations();
  }

  setMutations() {
    // network call
    queryMutations(makeMutationsArray(this.state.mutations))
      .then(({ mutationsAnalysis }) => {
        this.setState({
          drugResistances: mutationsAnalysis.drugResistance
        });
      });
  }

  handleCheckboxChange(mutationKey, name) {
    return (event) => {
      const target = event.target;
      const value = target.checked;

      this.setState({
        mutations: {
          ...this.state.mutations,
          [mutationKey]: {
            ...this.state.mutations[mutationKey],
            [name]: value
          }
        }
      });
    };
  }

  reset(e) {
    e && e.preventDefault();

    this.setState({
      mutations: {
        pr: {},
        rt: {},
        in: {}
      }
    })
  }

  render() {
    return (
      <Router>
        <div className="c-app">
          <Route
            path="/"
            exact
            render={(props) => <ResistanceInput {...props} analyze={this.state.analyze} mutations={this.state.mutations} setMutations={this.setMutations} handleCheckboxChange={this.handleCheckboxChange} reset={this.reset} />}
          />
          <Route
            path="/report"
            render={(props) => <ResistanceReport {...props} drugResistances={this.state.drugResistances} mutations={this.state.mutations} />}
          />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js